import {CountUp} from 'countup.js';

let inView = require('in-view');

/**
 * Initializes number counter module using inView and CountUp libraries
 * Number counter wrapper must have assigned class "number-counter"
 * Numbers must contain attribute "data-number-counter", value of "data-number"-attribute of this element will be used
 * as target number
 */
export default function InitNumberAnimation() {
	inView('.number-counter').on('enter', () => {
		AnimateNumbers();
	});
	AnimateNumbers();
}

function AnimateNumbers() {
	const numbers = document.querySelectorAll('.number-counter *[data-number-counter]');

	if (numbers.length === 0)
		return;

	numbers.forEach((number) => {
		const value = parseInt(number.dataset.numberCounter);
		const numAnim = new CountUp(number.id, value);

		if (!numAnim.error) numAnim.start();
		else throw new Error(numAnim.error);
	});
}
